module.exports = __webpack_public_path__ + "img/59_M1_knock_knock.bbb630af.jpg";